import { HeaderShell } from './_Parts/HeaderShell';
import { APP_SWITCH_APPEARANCE } from "../../../../_CORE/_RuntimeConfig/_Config/Acomodar/AppSwitchAppearance.js";
/*
    🔥 HEADER PRIVADO — RESERVADO PARA LOS ICONOS

    Sin marca (vive en el sidebar) y sin navegación (vive en el sidebar).
    Solo el botón que abre el sidebar en mobile, y las utilidades.
*/

export const AppHeaderPrivate = ({ utilities = null, onToggleAside = null, templateId = null }) => (

    <HeaderShell
        isPrivate
        templateId={templateId ?? APP_SWITCH_APPEARANCE.STYLES.HEADER_TOP_PRIVATE}
        brand={null}
        navItems={[]}
        utilities={utilities}
        onToggleAside={onToggleAside}
    />
);
